import { Component} from '@angular/core';
import { ActionCoCalculatorModel, ActionCoCalculatorMission, ActionCoMissionGroup, ActionCoMissionQuestion, ActionCoMissionPDCGrouped, ActionCoCollaborateurMission } from '../../../../models';
import { HttpService, CoreService } from '../../../../services';
import { ToastService } from '../../../../toast';
import { ActionCoService } from '../../action-co-services/action-co.service';
import { ActionCoCalculatorService } from '../../action-co-services/action-co-calculator.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-calculateur-calcul',
  templateUrl: './calculator-calcul.component.html',
  styleUrls: ['./calculator-calcul.component.css', '../action-co-calculator.component.css', '../../action-co-card.component.css', '../../action-co-action/action-co-action.component.css',]
})

export class CalculatorCalculComponent {
  public savingNewObligation: boolean = false;
  public NewObligationLine: ActionCoMissionPDCGrouped = new ActionCoMissionPDCGrouped();

  constructor(
    protected http: HttpService,
    public indParam: CoreService,
    public toast: ToastService,
    protected actionCoService: ActionCoService,
    public calculatorService: ActionCoCalculatorService
  ) { }
  //#region METHODES PUBLIQUES

  public SaveNewObligation(): void {
    const validDatas = this.CheckObligation(this.NewObligationLine);
    if (!validDatas) {
      this.toast.showAlertToast('veuillez renseigner les champs manquants');
      return;
    }
    this.savingNewObligation = true;
    const model: ActionCoCalculatorModel = new ActionCoCalculatorModel();

    model.Mode = "SAVE_OBLIGATION";
    model.Mission = this.calculatorService.Mission;
    if (!model.Mission)
      model.Mission = new ActionCoCalculatorMission();
    model.Obligations = [this.NewObligationLine];
    model.Client.Id = this.actionCoService.Model.Customer.Id;
    this.http.postHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/`, model).subscribe(
      (result: ActionCoCalculatorModel) => {
        this.savingNewObligation = false;
        if (!result.HasError) {
          (this.NewObligationLine as any).Deletable = true;
          this.NewObligationLine.isPdc = true;
          this.NewObligationLine.Code = result.Obligations[0].Code;
          this.NewObligationLine.IdDonnee = result.Obligations[0].IdDonnee;
          this.calculatorService.Mission.globalInformationGroup.Questions[1].Obligations.push(JSON.parse(JSON.stringify(this.NewObligationLine)));
          this.UpdateAmount(this.NewObligationLine, this.calculatorService.Mission.globalInformationGroup.Questions[1], this.calculatorService.Mission.globalInformationGroup, false, 'create');
          this.actionCoService.OnMissionAdd();

          this.NewObligationLine = new ActionCoMissionPDCGrouped();
        }
      });
  }

  private CheckObligation(obligation: ActionCoMissionPDCGrouped): boolean {
    let validDatas: boolean = true;
    switch (this.NewObligationLine.BillingMethod) {
      case 'FOR':
        if (!obligation.Quantity) {
          validDatas = false;
          (obligation as any).EmptyQuantity = true;
        }
        if (!obligation.QuantityPrice) {
          validDatas = false;
          (obligation as any).EmptyQuantityPrice = true;
        }
        (obligation as any).EmptyDuration = false;
        (obligation as any).EmptyDurationPrice = false;
        (obligation as any).EmptyBillingMethod = false;
        break;
      case 'TPS':
        if (!obligation.Duration) {
          validDatas = false;
          (obligation as any).EmptyDuration = true;
        }
        if (!obligation.DurationPrice) {
          validDatas = false;
          (obligation as any).EmptyDurationPrice = true;
        }
        (obligation as any).EmptyQuantity = false;
        (obligation as any).EmptyQuantityPrice = false;
        (obligation as any).EmptyBillingMethod = false;
        break;
      case '2':
      case 'NA':
        validDatas = false;
        (obligation as any).EmptyBillingMethod = true;
        (obligation as any).EmptyDuration = false;
        (obligation as any).EmptyDurationPrice = false;
        (obligation as any).EmptyQuantity = false;
        (obligation as any).EmptyQuantityPrice = false;
        break;
    }
    if (!obligation.Label) {
      validDatas = false;
      (obligation as any).EmptyLabel = true;
    }
    if (!obligation.Collaborateur) {
      validDatas = false;
      (obligation as any).EmptyCollaborateur = true;
    }
    return validDatas;
  }

  public DeleteFreeObligation(obligation: ActionCoMissionPDCGrouped, index: number): void {
    (obligation as any).Deleting = true;
    this.http.getHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/DELETE_OBLIGATION/${obligation.IdDonnee}|${this.calculatorService.Mission.Ident}`).subscribe(
      (result: ActionCoCalculatorModel) => {
        (obligation as any).Deleting = false;
        if (!result.HasError) {
          this.UpdateAmount(obligation, this.calculatorService.Mission.globalInformationGroup.Questions[1], this.calculatorService.Mission.globalInformationGroup, false, 'delete');
          this.calculatorService.Mission.globalInformationGroup.Questions[1].Obligations.splice(index, 1);
          this.actionCoService.OnMissionAdd();
        }
      });
  }

  //#region gestion des obligations/propriétés

  public BillingMethodToRange(methodValue: string): number {
    switch (methodValue.toUpperCase()) {
      case 'TPS':
        return 1;
      case 'FOR':
        return 3;
      default:
        return 2;
    }
  }

  public RangeToBillingMethod(eventValue: number, obli: ActionCoMissionPDCGrouped, quest: ActionCoMissionQuestion, group: ActionCoMissionGroup, isNewLine: boolean): void {
    switch (eventValue) {
      case 1:
        obli.BillingMethod = 'TPS';
        break;
      case 2:
        obli.BillingMethod = 'NA';
        break;
      case 3:
        obli.BillingMethod = 'FOR';
        break;
    }

    this.UpdateAmount(obli, quest, group, isNewLine);
  }

  public UpdateAmount(obli: ActionCoMissionPDCGrouped, quest: ActionCoMissionQuestion, group: ActionCoMissionGroup, isNewLine: boolean, actionNewObligation: string = ''): void {

    const discount: number = (obli.Discount ? obli.Discount : 0)
    if ((!isNewLine && actionNewObligation !== 'create') || actionNewObligation === 'delete') {
      this.calculatorService.Amount = this.calculatorService.Amount - obli.Amount;
      this.calculatorService.Mission.Amount = this.calculatorService.Mission.Amount - obli.Amount;
      group.Amount = group.Amount - obli.Amount;
      quest.Amount = quest.Amount - obli.Amount;

      this.calculatorService.Discount = this.calculatorService.Discount - discount;
      this.calculatorService.Mission.Discount = this.calculatorService.Mission.Discount - discount;
      group.Discount = group.Discount - discount;
    }
    if (actionNewObligation != 'delete') {
      switch (obli.BillingMethod.toUpperCase()) {
        case 'TPS':
          obli.Amount = obli.Duration * obli.DurationPrice - discount;
          break;
        case 'FOR':
          obli.Amount = obli.Quantity * obli.QuantityPrice - discount;
          break;
        default:
          obli.Amount = 0;
          obli.Discount = 0;
          break;
      }
      if (!isNewLine) {
        group.Discount = group.Discount + discount;
        this.calculatorService.Mission.Discount = this.calculatorService.Mission.Discount + discount;
        this.calculatorService.Discount = this.calculatorService.Discount + discount;

        group.Amount = group.Amount + obli.Amount;
        quest.Amount = quest.Amount + obli.Amount;
        this.calculatorService.Mission.Amount = this.calculatorService.Mission.Amount + obli.Amount;
        this.calculatorService.Amount = this.calculatorService.Amount + obli.Amount;
      }
    }
  }

  public DisplayGroupDiscount(group: ActionCoMissionGroup): void {
    let total: number = 0;
    group.Questions.forEach((question: ActionCoMissionQuestion) => {
      question.Obligations.forEach((obligation: ActionCoMissionPDCGrouped) => {
        if (obligation.Discount)
          total += obligation.Discount;
      });
    });
    group.Discount = total;
  }

  public OnCollaboChange(idCollab: any, obli: ActionCoMissionPDCGrouped, question: ActionCoMissionQuestion, group: ActionCoMissionGroup, isNewLine: boolean) {

    const coutCollab: ActionCoCollaborateurMission | undefined = this.calculatorService.Collaborateurs.find((collab: ActionCoCollaborateurMission) => collab.id == idCollab);
    if (coutCollab)
      obli.DurationPrice = coutCollab.Cout;
    this.UpdateAmount(obli, question, group, isNewLine);

  }

  public SumCacHours(col: string): number {
    let res: number = 0;
    this.calculatorService.Mission.Cacs.Values.forEach(row => {
      res += (row as any)[col];
    });
    return res;
  }

  public OnSaveCAC(): void {
    const model: ActionCoCalculatorModel = new ActionCoCalculatorModel();
    model.Mode = 'SAVE_CACS';
    model.Mission.Cacs = JSON.parse(JSON.stringify(this.calculatorService.Mission.Cacs));
    model.Mission.Ident = this.calculatorService.Mission.Ident;
    this.http.postHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/`, model).subscribe(
      (result: ActionCoCalculatorModel) => {
        if (!result.HasError) {
          this.calculatorService.Mission.Cacs = result.Mission.Cacs;
          this.calculatorService.Mission.Amount = result.Mission.Amount;
        }
      });
  }

  public OnSaveDiscout(): void {
    this.http.getHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/UPDATE_PROP_MISSIONCAC/${this.calculatorService.Mission.Ident}|MontRPRO|${this.calculatorService.Mission.Cacs.Discount}`).subscribe(
      (result: ActionCoCalculatorModel) => {
        if (!result.HasError) {
          const mt = ((this.SumCacHours('HoursSI') * this.calculatorService.Mission.Cacs.UnitPriceSI) + (this.SumCacHours('HoursRM') * this.calculatorService.Mission.Cacs.UnitPriceRM) + (this.SumCacHours('HoursSN') * this.calculatorService.Mission.Cacs.UnitPriceSN) + (this.SumCacHours('HoursJN') * this.calculatorService.Mission.Cacs.UnitPriceJN)) - this.calculatorService.Mission.Cacs.Discount;
          this.http.getHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/UPDATE_PROP_MISSIONCAC/${this.calculatorService.Mission.Ident}|MontaPRO|${mt}`).subscribe(

            (result: ActionCoCalculatorModel) => {
              if (!result.HasError) {
                this.calculatorService.Mission.Cacs.TotalAmountHT = mt;
                this.calculatorService.Mission.Amount = mt;
                this.calculatorService.Mission.Discount = this.calculatorService.Mission.Cacs.Discount;
                this.calculatorService.Amount = mt;
                this.calculatorService.Discount = this.calculatorService.Mission.Cacs.Discount;
              }
            });
        }
      });
  }

  public OnSaveMissionHour(label: string, value: string): void {
    let code: string = '';
    switch (label.toLocaleLowerCase()) {
      case 'interim':
        code = 'TpsItPRO';
        break;
      case 'inventaire':
        code = 'TpsIvPRO';
        break;
      case 'final':
        code = 'TpsFiPRO';
        break;
    }
    this.http.getHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/UPDATE_PROP_MISSIONCAC/${this.calculatorService.Mission.Ident}|${code}|${value}`).subscribe();
  }
  //#endregion
  //#endregion
}
